<template>
  <div class="container-fluid py-5 card-login">
    <div class="row justify-content-center h-100 align-items-center">
      <div class="col-12 col-xl-8 col-lg-9 col-md-10 improve-900">
        <div class="card bg-secondary shadow border-0">
          <div class="card-header bg-transparent pb-5">
            <img src="img/brand/logo-shippop.png" />
            <div class="px-lg-5 pt-lg-5 ">
              <h3 class="text-red">แจ้งปิดปรับปรุงระบบชั่วคราว</h3>
              <h3>{{`ใน${date} เวลา 21:00 - 22:00 น.`}}</h3>
              <hr style="width: 50%;"/>
              <h4>SHIPPOP SHOP อยู่ในระหว่างปิดปรับปรุงพัฒนาระบบ เพื่อเพิ่มประสิทธิภาพในการให้บริการให้ดียิ่งขึ้น</h4>
              <h4>มีผลทำให้ไม่สามารถใช้งานได้ชั่วคราว ขออภัยในความไม่สะดวกมา ณ ที่นี้</h4>
              <h5 class="pt-4 text-muted">“เราจะกลับมาและเราจะไม่หยุดพัฒนา” - SHIPPOP SHOP TEAM</h5>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from "moment";
moment.locale('th')
export default {
  name: "improve",
  data() {
    return {
      date: moment().startOf('day').format('LLLL').replace("เวลา 0:00", "")
    };
  },
  methods: {
  }
};
</script>
<style>
</style>
